import { getName as getCountryName, registerLocale } from 'i18n-iso-countries';

import enLocale from 'i18n-iso-countries/langs/en.json';

registerLocale(enLocale);
export function friendlyCountryName(countryCode: string | undefined) {
  if (!countryCode) {
    return '';
  }
  return getCountryName(countryCode, 'en');
}
